import { PLANTIO_ACTIONS_TYPES } from "./plantio.types";

import { createAction } from "../../utils/reducer/reducer";

export const setPlantio = (plantio) => {
	return createAction(PLANTIO_ACTIONS_TYPES.SET_PLANTIO, plantio);
};

export const setApp = (app) => {
	return createAction(PLANTIO_ACTIONS_TYPES.SET_APP, app);
};

export const setUseMulti = (useMulti) => {
	localStorage.setItem("useMulti", JSON.stringify(useMulti));
	return createAction(PLANTIO_ACTIONS_TYPES.SET_USE_MULTI, useMulti);
};

export const setAppFarmBox = (appFarmBox) => {
	return createAction(PLANTIO_ACTIONS_TYPES.SET_APP_FARMBOX, appFarmBox);
};

export const setSafraCilco = (safraCiclo) => {
	// salva no navegador automaticamente
	localStorage.setItem("safraCiclo", JSON.stringify(safraCiclo));

	return createAction(PLANTIO_ACTIONS_TYPES.SET_SAFRA_CICLO, safraCiclo);
};

export const setPlantioMapAll = (plantioArray) => {
	return createAction(
		PLANTIO_ACTIONS_TYPES.SET_PLANTIO_MAP_ALL,
		plantioArray
	);
};

export const setPluvi = (pluviArray) => {
	return createAction(PLANTIO_ACTIONS_TYPES.SET_PLUVI, pluviArray);
};

export const setPlantioCalendarDone = (calendarArray) => {
	return createAction(PLANTIO_ACTIONS_TYPES.SET_CALENDAR_DONE, calendarArray);
};

export const setPlantioColheitaAtual = (plantioColheitaArray) => {
	return createAction(PLANTIO_ACTIONS_TYPES.SET_PLANTIO_COLHEITA_ATUAL, plantioColheitaArray);
};

export const setColheitaPortalData = (colheitaDataArray) => {
	return createAction(PLANTIO_ACTIONS_TYPES.SET_COLHEITA_PORTAL_DATA, colheitaDataArray);
};
